import request from '@/utils/request'

export function listPointsExchangeGoods(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/pointsExchange.listPointsExchangeGoods',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function savePointsExchangeGoods(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/pointsExchange.savePointsExchangeGoods',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function updatePointsExchangeGoods(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/pointsExchange.updatePointsExchangeGoods',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function deletePointsExchangeGoods(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/pointsExchange.deletePointsExchangeGoods',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function listPointsExchangeOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/pointsExchange.listPointsExchangeOrder',
      method: 'get',
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function updatePointsExchangeOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/pointsExchange.updatePointsExchangeOrder',
      method: 'post',
      data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}
